<ion-radio-group [(ngModel)]="selectedPaperType">
  <ion-grid [fixed]="true">
    <ion-row>
      @for (paperType of paperTypesSorted(); track paperType.id) {
      <ion-col size="12" size-md="6">
        <app-option-selector
          [name]="paperType.name"
          [description]="paperType.description"
          [item]="paperType"
          [isSelected]="paperType == selectedPaperType()"
          (click)="onPaperTypeClick(paperType)"
          (dblclick)="onDoubleClick()">
        >
        </app-option-selector>
      </ion-col>
      }
    </ion-row>
  </ion-grid>
</ion-radio-group>
